import React from 'react';

/**
 * Renderiza um subconjunto simples de markdown vindo das respostas da Aurora Lyz:
 * - `**negrito**` inline
 * - linhas iniciadas em `#`/`##`/`###` (+ espaço) como título em destaque
 * Sem isso os `#` apareciam literalmente no texto (bug reportado em Kabbalah,
 * mas a mesma função estava duplicada em todas as páginas de skill).
 */
function renderInlineBold(line: string, keyPrefix: string | number) {
  const parts: React.ReactNode[] = [];
  let remaining = line;
  let key = 0;
  while (remaining.length > 0) {
    const boldIdx = remaining.indexOf('**');
    if (boldIdx === -1) { parts.push(remaining); break; }
    const closeIdx = remaining.indexOf('**', boldIdx + 2);
    if (closeIdx === -1) { parts.push(remaining); break; }
    if (boldIdx > 0) parts.push(remaining.slice(0, boldIdx));
    parts.push(
      <strong key={`${keyPrefix}-${key++}`} className="text-amber-300 font-semibold">
        {remaining.slice(boldIdx + 2, closeIdx)}
      </strong>
    );
    remaining = remaining.slice(closeIdx + 2);
  }
  return parts;
}

export function renderMarkdown(text: string) {
  const lines = text.split('\n');
  return lines.map((line, i) => {
    const headingMatch = line.match(/^#{1,6}\s+(.*)$/);
    if (headingMatch) {
      return (
        <div key={i} className="text-amber-300 font-semibold mt-3 mb-1 first:mt-0">
          {renderInlineBold(headingMatch[1], i)}
        </div>
      );
    }
    return (
      <React.Fragment key={i}>
        {renderInlineBold(line, i)}
        {i < lines.length - 1 && <br />}
      </React.Fragment>
    );
  });
}
